import {
  Component,
  Input,
  Output,
  EventEmitter } from '@angular/core';

@Component({
  selector: 'ns-type-ahead-search',
  template: require('./typeAheadSearch.component.html')
})
export class TypeAheadSearchComponent {
  @Input() typeAheadModel;
  @Input() typeAheadPlaceholder;
  @Input() noResultsText;
  @Input() noResultsLink;
  @Output() selectResult = new EventEmitter();

  constructor() {
    this.typeAheadActive = false;
    this.typeAheadText = '';
  }

  ngOnInit() {
    this.noResultsActive = this.noResultsLink !== '';
  }

  typeAheadGetResults(data) {
    this.typeAheadResults = [];
    const uInput = data.target.value.toLowerCase();
    if (uInput.length > 0) {
      this.typeAheadActive = true;

      this.typeAheadModel.forEach((item) => {
        const itemName = item.name.toLowerCase();
        if (itemName.indexOf(uInput) > -1) {
          this.typeAheadResults.push(item);
        }

      });

      return true;
    } else {
      return this.resetTypeAhead();
    }
  }

  typeAheadSelectResult(result) {
    this.selectResult.emit(result);
  }

  resetTypeAhead(event) {
    this.typeAheadText = '';
    this.typeAheadResults = [];
    this.typeAheadActive = false;
  }
}
